import { forwardRef } from "react";

/**
 * TextInput — input de texto del design system.
 *
 * Props extras:
 *   leftIcon   — nodo React que se muestra como icono a la izquierda
 *   rightSlot  — nodo React que se posiciona absolutamente a la derecha (ej: toggle de contraseña)
 *   inputSize  — "xs" | "sm" | "md" (default) | "lg"
 *   variant    — "error" | "success" | "warning"
 *
 * El resto de props se pasan directamente al <input>.
 */
const TextInput = forwardRef(function TextInput(
    { leftIcon, rightSlot, inputSize, variant, className = "", ...props },
    ref,
) {
    const sizeClass    = inputSize ? `input-${inputSize}` : "";
    const variantClass = variant   ? `input-${variant}`   : "";
    const paddingLeft  = leftIcon  ? "pl-10" : "";
    const paddingRight = rightSlot ? "pr-11" : "";

    const inputEl = (
        <input
            ref={ref}
            className={`input input-bordered w-full ${sizeClass} ${variantClass} ${paddingLeft} ${paddingRight} ${className}`.trim()}
            {...props}
        />
    );

    if (!leftIcon && !rightSlot) return inputEl;

    return (
        <div className="relative w-full">
            {leftIcon && (
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 pointer-events-none">
                    {leftIcon}
                </span>
            )}
            {inputEl}
            {rightSlot}
        </div>
    );
});

export default TextInput;
